/// <amd-module name="Core/Medius.Core.Web/Scripts/Helpers/migrationApisAvailableEndpointsList"/>

export function getAvailableMigratedWebApiEndpointsList(): string[] {
    return [
        "pv2/units",
        "pv2/units/default",
        "reports/filter/payment-term/autocomplete",
        "reports/share/receiver/autocomplete",
        "payment-request/type/\\d+/\\d+/custom-fields",
        "payment-request/types/\\d+",
        "payment-request/references",
        "RoutingTable/upload/\\d+",
        "MergedConfigurationEntitiesService/GetConfigurationEntityDirectForCompany",
        "MergedConfigurationEntitiesService/GetOrCreateConfigurationEntityForCompanyWithMetadata",
        "MergedConfigurationEntitiesService/GetMergedConfigurationEntity",
        "MergedConfigurationEntitiesService/GetMergedConfigurationEntityWithMetadata",
        "MergedConfigurationEntitiesService/GetMergedConfigurationEntityWithMetadataForParent",
        "MergedConfigurationEntitiesService/CreateConfigurationEntity",
        "MergedConfigurationEntitiesService/GetCompanyConfigurationDirect",
        "MergedConfigurationEntitiesService/CreateCompanyConfigurationEntity",
        "ExtendableSynchronization/(?:\\w+\\.)+\\w+",
        "ExtendableSynchronization/(?:\\w+\\.)+\\w+/\\d+",
        "currency/forcompany",
        "real-currencies",
        "procurement/locations/IsLocationIdDuplicated",
        "procurement/locations/IsLocationNameDuplicatedWithinCompany",
        "procurement/locations/\\d+",
        "procurement/locations/query",
        "documentManagement/\\d+$",
        "documentManagement/documents",
        "documentManagement/\\d+/archive",
        "documentManagement/\\d+/invalidate",
        "documentManagement/has-invalidate-and-archive-permission",
        "integration/ccf/v1/invoiceCapturedFields",
        "UserSettingsService/Update",
        "DefaultTranslationService/translations",
        "DefaultTranslationService/translations/[a-zA-Z0-9_-]+",
        "ArchiveSearchService/GetInvoices",
        "ArchiveSearchService/GetInvoicesCount",
        "ArchiveDocumentLoader/IsArchived",
        "ArchiveDocumentLoader/GetDocumentTaskWithTabs",
        "ArchiveAccountingService/GetCodeStrings",
        "ArchiveOrderbasedInvoiceService/GetInvoiceLines",
        "ArchiveOrderbasedInvoiceService/GetHeaderConnections",
        "ArchiveInvoiceService/GetInvoiceLines",
        "ArchiveInfoService/IsArchiveEnabled",
        "ArchiveSearchExportService/StartExportToExcelTask",
        "ArchiveAggregateQueueService/Rebuild",
        "ArchiveCompanyConfigurationQueueService/Rebuild",
        "DocumentApprovalTaskHandlingService/SendForReview",
        "DocumentApprovalTaskHandlingService/WithdrawFromReview",
        "DocumentApprovalTaskSavingService/SavePreReview",
        "DocumentApprovalTaskSavingService/SaveAuthorize",
        "DocumentApprovalTaskSavingService/SavePostControl",
        "DocumentApprovalTaskSavingService/SaveFinalPost",
        "DocumentApprovalTaskSavingService/SaveFinalPostError",
        "DocumentApprovalTaskSavingService/SaveEdit",
        "DocumentApprovalTaskSavingService/SaveValidationError",
        "DocumentApprovalTaskSavingService/SaveValidation",
        "DocumentApprovalTaskSavingService/SaveWorkflowError",
        "DocumentApprovalService/GetCustomFields",
        "TemplateAccountingObjectService/ValidateTemplateLine",
        "TemplateAccountingObjectService/Save",
        "TemplateAccountingObjectService/GetNewTemplateLine",
        "TemplateAccountingObjectService/GetAccountingTemplates",
        "TemplateAccountingObjectService/GetLatestAccountingTemplates",
        "TemplateAccountingObjectService/GetMostRecentLatestAccountingTemplate",
        "TemplateAccountingObjectService/GetTemplateCodeStrings",
        "TemplateAccountingObjectService/CreateTemplateFromAccounting",
        "TemplateAccountingObjectService/HasDefaultTemplateAccess",
        "TemplateAccountingObjectService/GetTemplateCodeStringsCount",
        "TemplateAccountingObjectService/GetDefaultTemplate",
        "TemplateAccountingObjectService/GetAccountingTemplatesForAutocompleter",
        "AccountingTemplateService/ApplyAccountingTemplate",
        "UserAdministrationServiceRestful/\\d+",
        "AccrualService/ApplyAccrualTemplate",
        "AccrualService/GetNewPeriods",
        "AccrualService/GetNewPeriod",
        "MediaManager/SendEmailCapture",
        "MediaManager/SendEmail",
        "MasterDataService/GetCompanyConfiguration",
        "MasterDataService/GetCompanyConfigurationDto",
        "MasterDataService/GetCustomFieldsContainer",
        "MasterDataService/GetCompanyDependantData",
        "MasterDataService/GetLineCustomFieldsPerspective",
        "MasterDataService/SupplierExistsInCompany",
        "MasterDataService/GetSuppliersForAutocompleter",
        "MasterDataService/GetPagedSuppliersForAutocompleter",
        "MasterDataService/GetDeliveryTermsForAutocompleter",
        "MasterDataService/GetActiveMasterDataForAutoCompleter",
        "MasterDataService/GetActiveDistributableUsersAutoCompleter",
        "MasterDataService/GetAllUsersAutoCompleter",
        "MasterDataService/GetAddresses",
        "MasterDataService/GetPaymentDetails",
        "MasterDataService/GetCurrencyForSupplier",
        "MasterDataService/CalculateGross",
        "MasterDataService/CalculateTotalAmount",
        "MasterDataService/GetCurrentTaskInformation",
        "MasterDataService/GetContractsForAutocompleter",
        "MasterDataService/GetAvailableCurrencies",
        "UserService/GetAvailableLanguages",
        "UserService/GetAvailableFormats",
        "UserService/GetAvailableTimeZones",
        "UserService/GetAvailableDefaultCompaniesIds",
        "UserService/GetEffectiveRoles",
        "invalidateArchivedInvoice/invalidate/\\d+",
        "AccountingTemplateAdministrationService/\\d+",
    ];
}

export function getMigrationCompletedEndpointsList(): string[] {
    return [
        "taxIndicatorRules/documentTypes",
        "pv2/userEmail",
        "pv2/userEmail/getByUserId/\\d+",
        "goodsReceiptNote/grnForDeliveryLines",
        "pv2/resolutionConfiguration",
        "reports/role/autocomplete",
        "authorizationGroupCurrency",
        "CreditMemo/lines/\\d+",
        "reports/schedule/receiver/autocomplete",
        "bulkInbox/availableDocuments",
        "followupGroupCompany",
        "administration/customlist/companies",
    ];
}